var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.add_test_screen
        ? [
            _c("div", { staticClass: "row gutter-sm" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-12" },
                [
                  _c(
                    "q-field",
                    { attrs: { count: 256 } },
                    [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("title"),
                          count: 10,
                          error: _vm.$v.title.$error
                        },
                        on: { input: _vm.$v.title.$touch },
                        model: {
                          value: _vm.title,
                          callback: function($$v) {
                            _vm.title = $$v
                          },
                          expression: "title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("q-table", {
              staticClass: "q-mt-lg",
              attrs: {
                data: _vm.questions,
                columns: _vm.columns_questions,
                pagination: _vm.server_pagination,
                loading: _vm.loading,
                "row-key": "id",
                "no-data-label": _vm.$t("no_data_avaliable"),
                "no-results-label": _vm.$t("no_results_found"),
                "loading-label": _vm.$t("loading_data"),
                "rows-per-page-label": _vm.$t("items_per_page"),
                "rows-per-page-options": [0],
                "binary-state-sort": ""
              },
              on: {
                "update:pagination": function($event) {
                  _vm.server_pagination = $event
                },
                request: _vm.request_questions
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "top",
                    fn: function(props) {
                      return [
                        _c("div", { staticClass: "q-table-title" }, [
                          _vm._v(_vm._s(_vm.$t("questions")))
                        ]),
                        _c("div", { staticClass: "col" }),
                        !_vm.id_test
                          ? _c("q-btn", {
                              staticClass: "q-mr-md",
                              attrs: {
                                color: "primary",
                                icon: "far fa-plus",
                                label: _vm.$t("add_from_model")
                              },
                              on: {
                                click: function($event) {
                                  _vm.add_model = true
                                }
                              }
                            })
                          : _vm._e(),
                        _c("q-btn", {
                          attrs: {
                            color: "secondary",
                            icon: "far fa-plus",
                            label: _vm.$t("new")
                          },
                          on: {
                            click: function($event) {
                              return _vm.showQuestion(0)
                            }
                          }
                        })
                      ]
                    }
                  },
                  {
                    key: "header",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            { key: col.name, attrs: { props: props } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          )
                        }),
                        1
                      )
                    }
                  },
                  {
                    key: "body",
                    fn: function(props) {
                      return _c(
                        "q-tr",
                        { attrs: { props: props } },
                        [
                          _c(
                            "q-td",
                            {
                              key: "id",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.id) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            { key: "title", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(props.row.title) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "live_class_evaluation_question_type",
                              attrs: { props: props }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.getEvaluationType(
                                      props.row
                                        .live_class_evaluation_question_type
                                    )
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "actions",
                              attrs: { "auto-width": "", props: props }
                            },
                            [
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    round: "",
                                    color: "primary",
                                    icon: "far fa-pencil-alt"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.showQuestion(props.row.actions)
                                    }
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "q-btn",
                                {
                                  attrs: {
                                    flat: "",
                                    round: "",
                                    color: "negative",
                                    icon: "far fa-trash-alt"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.confirmRemove(
                                        props.row.actions
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("q-tooltip", [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("delete_tooltip")) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ])
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }
                  }
                ],
                null,
                false,
                1234227152
              )
            }),
            _c("div", { staticClass: "row gutter-sm q-mt-md" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-4" },
                [
                  _c("p", { staticClass: "caption" }, [
                    _vm._v(_vm._s(_vm.$t("status")))
                  ]),
                  _c("q-btn-toggle", {
                    attrs: {
                      "toggle-color": _vm.getColorStatusButton,
                      options: _vm.statuses
                    },
                    model: {
                      value: _vm.status,
                      callback: function($$v) {
                        _vm.status = $$v
                      },
                      expression: "status"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-3",
                  class: _vm.getOrder("cancel")
                },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "tertiary",
                      label: _vm.$t("back"),
                      icon: "far fa-chevron-left"
                    },
                    on: {
                      click: function($event) {
                        return _vm.returnToTests()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "col-xs-12 col-sm-3",
                  class: _vm.getOrder("save")
                },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "secondary",
                      label: _vm.$t("save"),
                      icon: "far fa-save"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveTest("save_test")
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _c("new-question", {
        attrs: {
          id_classes: _vm.id_classes,
          id_test: _vm.id_test,
          id_question: _vm.id_question,
          add_question: _vm.add_question,
          test_types: _vm.test_types
        },
        on: { returnToQuestions: _vm.returnToQuestions }
      }),
      _c("new-question-model", {
        attrs: {
          id_classes: _vm.id_classes,
          add_model: _vm.add_model,
          model_types: _vm.model_types,
          test_types: _vm.test_types
        },
        on: { returnToQuestionsFromModel: _vm.returnToQuestionsFromModel }
      }),
      _c(
        "q-dialog",
        {
          on: {
            ok: function($event) {
              return _vm.removeModule()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeModule()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }